export default __webpack_public_path__ + "static/parisco-83dc8772a5c5fb1cfb1d63d1812253cc.png";